import React from "react";
import "../../../Css/Courses.css";
import menu3 from "../Img/menu3.jfif";
import menu4 from "../Img/menu4.jpg";
import Typist from "react-typist";

function Courses() {
  return (
    <div className="Courses_home_section">
      <Typist className="Courses_home_section_typing">
        <span className="Courses_home_section_h1">
          {" "}
          Hello! Welcome here are <br /> <br /> some of the most popular
          projects{" "}
        </span>
        <Typist.Backspace count={1} delay={200} />
        <br />
        <br />
        <span className="Courses_home_section_span">
          {" "}
          That i build and some of them are just for sel!{" "}
        </span>
      </Typist>
      <Next_Course />
      <Courses_Footer />
    </div>
  );
}

function Next_Course() {
  return (
    <div className="section_two_work_experience">
      <h1 className="res_foods_h1_title">My projects </h1>
      <hr className="res_foods_hr" />
      <div className="responsive">
        <div className="gallery">
          <a target="_blank" href="img_5terre.jpg">
            <img src={menu3} alt="Cinque Terre" width="600" height="400" />
          </a>
          <div className="desc">
            <h3 className="section_two_work_experience_h3_title">
              Title and article
            </h3>
            <p className="section_two_work_experience_p">
              Add a description of the image here
            </p>
            <a href="#" className="res_food_a_link">
              Links
            </a>
          </div>
        </div>
      </div>

      <div className="responsive">
        <div className="gallery">
          <a target="_blank" href="img_lights.jpg">
            <img src={menu4} alt="Northern Lights" width="600" height="400" />
          </a>
          <div className="desc">
            <h3 className="section_two_work_experience_h3_title">
              Title and article
            </h3>
            <p className="section_two_work_experience_p">
              Add a description of the image here
            </p>
            <a href="#" className="res_food_a_link">
              Links
            </a>
          </div>
        </div>
      </div>

      <div className="responsive">
        <div className="gallery">
          <a target="_blank" href="img_lights.jpg">
            <img src={menu3} alt="Northern Lights" width="600" height="400" />
          </a>
          <div className="desc">
            <h3 className="section_two_work_experience_h3_title">
              Title and article
            </h3>
            <p className="section_two_work_experience_p">
              Add a description of the image here
            </p>
            <a href="#" className="res_food_a_link">
              Links
            </a>
          </div>
        </div>
      </div>

      <div className="responsive">
        <div className="gallery">
          <a target="_blank" href="img_mountains.jpg">
            <img src={menu4} alt="Restaurant" width="600" height="400" />
          </a>
          <div className="desc">
            <h3 className="section_two_work_experience_h3_title">
              Title and article
            </h3>
            <p className="section_two_work_experience_p">
              Add a description of the image here
            </p>
            <a href="#" className="res_food_a_link">
              Links
            </a>
          </div>
        </div>
      </div>

      <div className="responsive">
        <div className="gallery">
          <a target="_blank" href="img_mountains.jpg">
            <img src={menu3} alt="Restaurant" width="600" height="400" />
          </a>
          <div className="desc">
            <h3 className="section_two_work_experience_h3_title">
              Title and article
            </h3>
            <p className="section_two_work_experience_p">
              Add a description of the image here
            </p>
            <a href="#" className="res_food_a_link">
              Links
            </a>
          </div>
        </div>
      </div>

      <div className="responsive">
        <div className="gallery">
          <a target="_blank" href="img_mountains.jpg">
            <img src={menu4} alt="Restaurant" width="600" height="400" />
          </a>
          <div className="desc">
            <h3 className="section_two_work_experience_h3_title">
              Title and article
            </h3>
            <p className="section_two_work_experience_p">
              Add a description of the image here
            </p>
            <a href="#" className="res_food_a_link">
              Links
            </a>
          </div>
        </div>
      </div>

      <div className="responsive">
        <div className="gallery">
          <a target="_blank" href="img_mountains.jpg">
            <img src={menu3} alt="Restaurant" width="600" height="400" />
          </a>
          <div className="desc">
            <h3 className="section_two_work_experience_h3_title">
              Title and article
            </h3>
            <p className="section_two_work_experience_p">
              Add a description of the image here
            </p>
            <a href="#" className="res_food_a_link">
              Links
            </a>
          </div>
        </div>
      </div>

      <div className="responsive">
        <div className="gallery">
          <a target="_blank" href="img_mountains.jpg">
            <img src={menu4} alt="Restaurant" width="600" height="400" />
          </a>
          <div className="desc">
            <h3 className="section_two_work_experience_h3_title">
              Title and article
            </h3>
            <p className="section_two_work_experience_p">
              Add a description of the image here
            </p>
            <a href="#" className="res_food_a_link">
              Links
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

// Footer section
function Courses_Footer() {
  return (
    <div className="footer_section">
      <p>© Copyright Murtaza. All Rights Reserved </p>
    </div>
  );
}

export default Courses;
